import { render, staticRenderFns } from "./releasePolicy.vue?vue&type=template&id=2475b5a9&scoped=true&"
import script from "./releasePolicy.vue?vue&type=script&lang=js&"
export * from "./releasePolicy.vue?vue&type=script&lang=js&"
import style0 from "./releasePolicy.vue?vue&type=style&index=0&id=2475b5a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475b5a9",
  null
  
)

export default component.exports